export { Tabs, TabPanel } from './tabs';
